import { api } from '@/core/api/client'
import type { Company } from '@/features/classes/stores/types'

const companiesCollection = api.collection<Company>('companies')

export async function fetchCompanies(): Promise<Company[]> {
  return companiesCollection.getFullList({ sort: 'name' })
}

export async function fetchCompanyById(id: string): Promise<Company | null> {
  try {
    return await companiesCollection.getOne(id)
  } catch {
    return null
  }
}

export async function fetchActiveCompanies(): Promise<Company[]> {
  const all = await companiesCollection.getFullList()
  return all.filter((c) => c.status === 'active')
}

export async function createCompany(data: Partial<Company>): Promise<Company> {
  return companiesCollection.create(data as Record<string, unknown>)
}

export async function updateCompany(id: string, data: Partial<Company>): Promise<Company> {
  return companiesCollection.update(id, data as Record<string, unknown>)
}

export async function deleteCompany(id: string): Promise<void> {
  await companiesCollection.delete(id)
}
